import styled from 'styled-components';

export const ListItem = styled.ul`
  width: 100%;
  padding: 0;
  margin: 0;
  list-style: none;
  border-radius: 3px;
  display: flex;
  flex-direction: column;

  @media (max-width: 650px) {
    align-self: flex-start;
  }

  > hr {
    margin: 0;
    height: 1px;
    background-color: #e6e6e6;
    border: none;
    width: 88%;
    align-self: center;

    &:not(:only-child) {
      &:last-child {
        display: none;
      }
    }
  }
  li {
    display: flex;
    justify-content: space-between;
    -webkit-box-align: center;
    align-items: center;
    flex-wrap: wrap;

    cursor: pointer;
    font-weight: 700;
    font-size: 14px;

    > div {
      width: '346px';
    }
  }
`;
